import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { setSupplierDataGroup } from '../store/slices/productSlice';
import { isOperatingContextReady, useOperatingContext } from '../utils/operatingContextLifecycle';
import { useSelectedOperatingGroup } from './useSelectedOperatingGroup';

export const useSupplierDataScope = () => {
  const dispatch = useAppDispatch();
  const context = useOperatingContext();
  const token = useAppSelector(state => state.auth.token);
  const { groupId: selectedGroupId, changedInAnotherTab } = useSelectedOperatingGroup();
  const {
    supplierDataGroupId, supplierDataEpoch, suppliers: storedSuppliers, supplierProducts: storedSupplierProducts,
  } = useAppSelector(state => state.product);
  const contextReady = isOperatingContextReady(context, token) && !changedInAnotherTab;
  const groupId = contextReady ? selectedGroupId : null;

  useEffect(() => {
    if (contextReady && groupId !== null && supplierDataGroupId !== groupId)
      dispatch(setSupplierDataGroup(groupId));
  }, [contextReady, dispatch, groupId, supplierDataGroupId]);

  const isCurrent = contextReady && groupId !== null && supplierDataGroupId === groupId;
  return {
    groupId: isCurrent ? groupId : null,
    epoch: supplierDataEpoch,
    isCurrent,
    suppliers: isCurrent ? storedSuppliers : [],
    supplierProducts: isCurrent ? storedSupplierProducts : [],
  };
};
